import React from 'react';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Inventory.css';

const Inventory = () => {
	const [fruits, setFruit] = useState([]);
	useEffect(() => {
		fetch('https://safe-hamlet-12951.herokuapp.com/inventory')
			.then(res => res.json())
			.then(data => setFruit(data));
	}, [])
	let navigate = useNavigate();
	const navigateTomanageFruit = (id) => {
		navigate(`/inventory/${id}`);
	}
	return (
		<section id='inventory' className='home-inventory'>
			<h1 className='section-title'> Inventory  </h1>
			<div className="fruits-container section-center">

				{
					fruits.map(fruit => <div key={fruit._id}>

						<div className='single-item'>
							<div className="img-container">
								<img src={fruit.img} alt="" />
							</div>
							<article className='item-info'>
								<div className="fruit-info-header">
									<div className="name-price">
										<h4 className="fruit-name">{fruit.name}</h4>
										<p className='fruit-price'> Price : {fruit.price}</p>
									</div>
									<div className="quantity-supplier">
										<p> Supplier : {fruit.supplier} </p>
										<p>Quantity : {fruit.quantity} kg </p>
									</div>

								</div>
								<div className="fruit-description">
									<p>
										{fruit.description}
									</p>
								</div>
								<div className="fruit-footer">
									<p>
										<button className='fruit-btn' onClick={() => navigateTomanageFruit(fruit._id)}>Manage {fruit.name} </button>
									</p>

								</div>
							</article>
						</div>


					</div>)
				}









			
			</div>
			<Link className='btn btn-info w-25 p-2 mx-auto d-block' to='/allinventory' > All Fruits </Link>
		</section>
	);
};

export default Inventory;